export default __webpack_public_path__ + "static/media/FooterLogo.3e7368e8.svg";